module.exports = __webpack_public_path__ + "static/media/0325_IMG_LES_MURS_CHROMATIC_CH2_1006.3797b829.webp";